import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { Action } from "../constants/interfaces";
import api from "../utils/api";

interface State {
  error: Error | null;
  loading: boolean;
}

export function getInitialState(): State {
  return {
    loading: false,
    error: null
  };
}

export const registerTypes = {
  GET_RESTRICTION_NOTICE_REQUEST: "GET_INSTRUMENTS_REQUEST",
  GET_RESTRICTION_NOTICE_RESPONSE: "GET_RESTRICTION_NOTICE_RESPONSE"
};

export const registerActions: any = {
  getRestrictionNotice: (nhi: string, surname: string) => async (
    dispatch: ThunkDispatch<{}, {}, AnyAction>
  ) => {
    dispatch({
      type: registerTypes.GET_RESTRICTION_NOTICE_REQUEST
    });
    try {
      const { data: notice } = await api.get(
        `/registers/searchRestrictionNotices?surname=${surname}&nhi=${nhi}`
      );

      // instead of storing the data in reducer state
      // we return the response directly from the action
      // this prevents the data being accessible outside of the component lifecyle
      // and aids security over the restriction notice data
      dispatch({
        type: registerTypes.GET_RESTRICTION_NOTICE_RESPONSE,
        payload: null,
        error: false
      });
      return notice;
    } catch (e) {
      dispatch({
        type: registerTypes.GET_RESTRICTION_NOTICE_RESPONSE,
        payload: e,
        error: true
      });
      return e;
    }
  }
};

export default function register(state = getInitialState(), action: Action) {
  const { type, payload, error } = action;

  switch (type) {
    case registerTypes.GET_RESTRICTION_NOTICE_REQUEST: {
      return { ...state, loading: true, error: null };
    }
    case registerTypes.GET_RESTRICTION_NOTICE_RESPONSE: {
      if (error) {
        return {
          ...state,
          loading: false,
          error: payload
        };
      }
      return {
        ...state,
        loading: false,
        error: null
      };
    }
  }
  return state;
}
